const { createContext, useContext } = require('react')

export const RegistrationFormContext = createContext({})

export const useRegistrationForm = () => useContext(RegistrationFormContext)
